module.exports = __webpack_public_path__ + "static/movies-3df9e1b70ffc8578e4a608a25c615ce4.jpg";